import {
  CATALOG_FONT_SCALE_MAX,
  CATALOG_FONT_SCALE_MIN,
} from "@/features/catalog/stores/catalogStore";

/**
 * カタログ外観設定をCSSカスタムプロパティへ落とすための純関数群。
 * 反映処理そのものは DesktopCatalogGridLayout が行う。
 */

/**
 * --catalog-font-scale に入れる倍率。CSSは calc(... * var(--catalog-font-scale, 1))
 * で受けるため、%ではなく倍率へ変換する。壊れた値・範囲外はここで丸めるので、
 * calc()へ0や負数が流れてカタログの文字が消えることはない。
 */
export function resolveCatalogFontScaleValue(percent: number): string {
  const clamped = Math.max(
    CATALOG_FONT_SCALE_MIN,
    Math.min(
      CATALOG_FONT_SCALE_MAX,
      Number.isFinite(percent) ? Math.floor(percent) : CATALOG_FONT_SCALE_MIN,
    ),
  );
  return String(clamped / 100);
}
